import { useTranslation } from 'react-i18next'

const useTourSeeMoreTarifs = () => {
  const { t } = useTranslation('tour')
  return [
    {
      selector: '.joyride-tourSeeMoreTarifs-Accordion',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.welcomeMessage')}</p>
          <span>{t('tour.TarifsMessage')}</span>
        </div>
      ),
    },
  ]
}

export default useTourSeeMoreTarifs
